import { Injectable, OnDestroy } from "@angular/core";
import { MenuRoutes } from "./sidebar-routes.config";
import { MenuItem } from "./menu-item";
import { AuthService } from "../auth/auth.service";
import { BehaviorSubject, Subject, takeUntil } from "rxjs";
import { ConfiguracoesService } from "../../pages/full-pages/configuracoes/configuracoes.service";
import { Permission, hasPerm } from "../auth/permission.enum";
import { ConfigModulosService } from "app/pages/full-pages/configmodulos/configmodulos.service";
import { ContaService } from './../../pages/full-pages/conta/conta.service';
import { TranslateService } from '@ngx-translate/core';
import { TipoDocumentoAdminService } from "app/pages/full-pages/customs/tipo-documento-admin/tipo-documento-admin.service";
import { AbTenant } from "app/abstract/full-pages/admin/tenant.abstract";
import { AbGestaoPreCadastros } from "app/abstract/full-pages/gestao-pre-cadastros/gestao-pre-cadastros.abstract";

@Injectable({ providedIn: 'root' })
export class SidebarService implements OnDestroy {
  public readonly menu = new BehaviorSubject<MenuItem[]>([]);
  public nomeDivisao: string;
  public nomeUnidade: string;
  public contemPreCadastros: boolean = false;

  private readonly destroy$ = new Subject();

  constructor(
    public menuRoutes: MenuRoutes,
    private configuracoesService: ConfiguracoesService,
    private configModulosService: ConfigModulosService,
    public tenantService: AbTenant,
    public authService: AuthService,
    public contaService: ContaService,
    public translate: TranslateService,
    public tipoDocAdmService: TipoDocumentoAdminService,
    private gestaoPreCadastrosService: AbGestaoPreCadastros,
  ) { }

  public createRoutes() {
    const user = this.authService.getUsuarioStorage();
    if (!user) return;

    const configModulos = this.configModulosService.getConfigModulosStorage();

    this.contemPreCadastros = false;
    if (user.integrador) {
      this.gestaoPreCadastrosService.getExistsAguardando()
        .pipe(takeUntil(this.destroy$))
        .subscribe((contem: boolean) => { this.contemPreCadastros = contem; });
    }

    this.buildMenu(configModulos);
  }

  private buildMenu(configModulos: any) {
    const identifierTenant = this.tenantService.getOnlyNumberIdenfiersTenant();
    const menuItem: MenuItem[] = [];

    this.menuRoutes.createRoutes(this, configModulos).map((m: MenuItem) => {
      if (m.show) {
        m.submenu = m.submenu.filter(item => {
          if (item.tenant) {
            item.path = this.prepararMenusTenant(item, identifierTenant);
            return identifierTenant != undefined;
          }
          return item.show;
        });
        if (m.submenu.length === 0 && m.path.length === 0) m.show = false;
        menuItem.push(m);
      }
    });

    this.prepararNomesUnidadeEDivisao(menuItem);
    this.menu.next(menuItem);
  }

  public clearRoutesMenu() {
    this.menu.next([]);
  }

  public clearRoutes() {
    this.clearRoutesMenu();
    this.authService.saveTokenLGPD();
  }

  private prepararMenusTenant(menu: MenuItem, identifierTenant: string) {
    if (menu.path.charAt(menu.path.length - 1) == "/") {
      return menu.path + identifierTenant;
    } else {
      return menu.path + "/" + identifierTenant;
    }
  }

  private prepararNomesUnidadeEDivisao(menuItem: MenuItem[]) {
    if (this.tenantService.getTenantStorage() != null || hasPerm(Permission.CONFIGURACOES_READ)) {
      this.configuracoesService.getConfiguracoes().pipe(takeUntil(this.destroy$)).subscribe(
        (configuracoes) => {
          this.nomeDivisao = configuracoes.divisao.toString();
          this.nomeUnidade = configuracoes.unidade.toString();
          menuItem.forEach(item => {
            if (item.badgeClass === 'Divisões') {
              item.badgeClass = this.nomeDivisao;
            }

            if (item.badgeClass === 'Unidades') {
              item.badgeClass = this.nomeUnidade;
            }
          });
          const configuracaoJson = JSON.stringify(configuracoes);
          sessionStorage.setItem("configuracaoConta", configuracaoJson);
          return;
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
